var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    rx: 40,
    fill: "#2a4194"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206,206h-9.62V184.2a16.93,16.93,0,0,0-12.82-16.44L114.6,150.41a8.94,8.94,0,0,1-6.77-8.69V119.2a4,4,0,0,0-8,0v22.52a16.94,16.94,0,0,0,12.81,16.45l68.94,17.35a8.93,8.93,0,0,1,6.77,8.68V206H178.16a4,4,0,0,0-4,4v80.43a4,4,0,0,0,4,4H206a4,4,0,0,0,4-4V210A4,4,0,0,0,206,206Zm-4,80.43H182.16V214H202Zm52.57-179.25A11.83,11.83,0,1,0,266.37,119,11.84,11.84,0,0,0,254.54,107.19Zm0,15.66a3.83,3.83,0,1,1,3.83-3.83A3.83,3.83,0,0,1,254.54,122.85Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.54,89.56H129.46a29.64,29.64,0,0,0,0,59.28H254.54a29.64,29.64,0,0,0,0-59.28ZM129.46,140.84a21.64,21.64,0,0,1,0-43.28H234.35a29.5,29.5,0,0,0,0,43.28Zm125.08,0a21.64,21.64,0,1,1,21.63-21.64A21.67,21.67,0,0,1,254.54,140.84Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.a4e8a4040c47a64493def7921b38d01b.svg";
export { ForwardRef as ReactComponent };